import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {OverlayPanel} from 'primeng/overlaypanel';

@Component({
  selector: 'si-overlay-panel',
  templateUrl: './overlay-panel.component.html',
  styleUrls: ['./overlay-panel.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class OverlayPanelComponent implements OnInit, OnDestroy {
  @Input() dismissable = true;
  @Input() appendTo: any;
  @Input() styleClass: string;
  @Output() hidePanel = new EventEmitter<any>();
  @ViewChild('pOverlayPanel', {static: true}) pOverlayPanel: OverlayPanel;
  onScrollBound;
  visible = false;

  constructor(
    private el: ElementRef
  ) {
  }

  ngOnInit() {
    // We need to bind 'this' before setting this function as event listener.
    this.onScrollBound = this.onScroll.bind(this);
  }

  onScroll(event): void {
    if (this.el.nativeElement.contains(event.target)) {
      return;
    }

    this.pOverlayPanel.hide();
    window.removeEventListener('scroll', this.onScrollBound, true);
  }

  toggle(event: MouseEvent): void {
    window.addEventListener('scroll', this.onScrollBound, true);
    this.pOverlayPanel.toggle(event);
  }

  hide(): void {
    this.pOverlayPanel.hide();
  }

  onHidePanel(): void {
    window.removeEventListener('scroll', this.onScrollBound, true);
    this.visible = false;
    this.hidePanel.emit();
  }

  onShowPanel(): void {
    this.visible = true;
  }

  ngOnDestroy() {
    window.removeEventListener('scroll', this.onScrollBound, true);
  }
}
